import * as React from 'react';
import { Icon } from '../../Icon';
import { IIcon } from '../../../interfaces/IIcon';

export function RouteIcon({ width, height, viewBox, style, className }: IIcon) {
    const newViewProps = '0 0 16 17' ?? viewBox;
    return (
        <Icon
            width={width}
            height={height}
            viewBox={newViewProps}
            style={style}
            className={className}
        >
            <g>
                <path d="M9 4C9 2.07 10.57 0.5 12.5 0.5C14.43 0.5 16 2.07 16 4C16 5.796 13.192 8.977 12.872 9.334C12.777 9.439 12.642 9.5 12.5 9.5C12.358 9.5 12.223 9.439 12.128 9.334C11.808 8.977 9 5.796 9 4ZM11 4C11 4.828 11.672 5.5 12.5 5.5C13.328 5.5 14 4.828 14 4C14 3.172 13.328 2.5 12.5 2.5C11.672 2.5 11 3.172 11 4ZM0 6.839C0 6.634 0.125 6.45 0.314 6.374L5 4.5V14.738L0.686 16.464C0.626 16.488 0.563 16.5 0.5 16.5C0.401 16.5 0.304 16.47 0.22 16.414C0.083 16.321 0 16.166 0 16V6.839ZM13.616 10.002C13.332 10.318 12.925 10.5 12.5 10.5C12.075 10.5 11.668 10.318 11.384 10.002C11.282 9.88904 11.151 9.74004 11 9.56304V16.5L15.686 14.626C15.876 14.551 16 14.366 16 14.162V6.81104C15.181 8.19804 14.086 9.47804 13.616 10.002ZM6 4.5L8.315 5.426C8.694 6.41 9.361 7.447 10 8.308V16.338L6 14.738V4.5Z" />
            </g>
        </Icon>
    );
}
